import React, { useEffect, useState } from "react";
import { BEDTYPES, getMonth } from "./shared/Utils";

const PropertyTable = ({
  tableData,
  currSymbol,
  currRate,
  unitTypes,
  unitType,
  unitAvailable,
  statusCode,
}) => {
  const [filterData, setFilterData] = useState([]);
  const [areUnitsAvailable, setAreUnitsAvailable] = useState(false);

  const unitPrice = (rate) => {
    return rate !== null ? Math.round(rate * currRate) : "N/A";
  };
  useEffect(() => {
    const filData = Object.keys(tableData)
      ?.reverse()
      ?.map((t) =>
        tableData[t].filter((tt) => unitTypes.toString().includes(tt.aptType))
      );
    setFilterData(filData);

    const currUnits = unitTypes?.reduce((isAvail, unit) => {
      if (unitAvailable?.[unit]) isAvail = true;
      return isAvail;
    }, false);
    setAreUnitsAvailable(currUnits);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unitTypes, tableData]);
  return (
    <ul className="price-table">
      <li className={`pt-row ${(unitAvailable && !unitAvailable?.[unitType]) || statusCode !== 200 ? "no-unit": ""}`}>
        <ul className="d-flex pt-ul">
          <li className={`pt-col ${unitTypes?.length > 1 ? "multi" : ""}`}>
            Month/Year
          </li>
          {unitTypes?.length > 1 ? (
            <li className="pt-col multi">Unit Type</li>
          ) : (
            ""
          )}
          <li className="pt-col pt-low">Low Price</li>
          <li className="pt-col pt-avg">Average Price</li>
          <li className="pt-col">High Price</li>
        </ul>
      </li>
      {areUnitsAvailable || (unitTypes?.length > 1 && filterData.length > 0) ? (
        filterData?.map((units, ind) => {
          return units.length > 0 ? (
            <React.Fragment key={ind}>
              <li
                className={`pt-row ${unitTypes?.length > 1 ? "pt-multi" : ""}`}
              >
                <ul className="d-flex pt-ul">
                  <li
                    className={`pt-col ${
                      unitTypes?.length > 1 ? "multi purple" : ""
                    }`}
                  >
                    {units.length > 0 ? getMonth(units?.[0]?.yearMonth) : ""}
                  </li>
                  {unitTypes?.length > 1 ? (
                    <li
                      className={`pt-col ${
                        unitTypes?.length > 1 ? "multi" : ""
                      }`}
                    >
                      <ul>
                        {units.map((unit, index) => {
                          return (
                            <li
                              key={index}
                              className={`left ${
                                unitType === unit.aptType ? "purple" : "grey"
                              }`}
                            >
                              {" "}
                              {BEDTYPES[unit.aptType] ? (
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: BEDTYPES[unit.aptType],
                                  }}
                                />
                              ) : (
                                unit.aptType
                              )}{" "}
                            </li>
                          );
                        })}
                      </ul>
                    </li>
                  ) : (
                    ""
                  )}
                  <li className="pt-col pt-low">
                    <ul>
                      {units.map((unit, index) => {
                        return (
                          <li key={index}>{`${currSymbol}${unitPrice(
                            unit.minRate
                          )}`}</li>
                        );
                      })}
                    </ul>
                  </li>
                  <li className="pt-col pt-avg">
                    <ul>
                      {units.map((unit, index) => {
                        return (
                          <li
                            key={index}
                            className={`${
                              unitType === unit.aptType ? "purple" : "grey"
                            }`}
                          >{`${currSymbol}${unitPrice(unit.avgRate)}`}</li>
                        );
                      })}
                    </ul>
                  </li>
                  <li className="pt-col">
                    <ul>
                      {units.map((unit, index) => {
                        return (
                          <li key={index}>{`${currSymbol}${unitPrice(
                            unit.maxRate
                          )}`}</li>
                        );
                      })}
                    </ul>
                  </li>
                </ul>
              </li>
            </React.Fragment>
          ) : (
            <React.Fragment key={ind}></React.Fragment>
          );
        })
      ) : (
        <div className="no-rates">
          {(unitAvailable && !unitAvailable?.[unitType]) || statusCode !== 200
            ? "Market rates not available. Please reach out to your Dwellworks Living contact for insight into this market."
            : ""}
        </div>
      )}
    </ul>
  );
};

export default PropertyTable;
